import { connect } from 'react-redux'
import MaintenanceAuditCardsComponent from '../components/MaintenanceAuditCardsComponent.jsx';
import {
    clean,
    forwardToFindAuditableMCards,
    forwardToAssignAuditingCardTarget,
    forwardToSortAuditableMaintenanceCards,
    forwardToFindPhotosByCard,
    changePhotoListPreviousPage
} from '../actions';

const mapStateToProps = (state) => ({

    request: state.getIn(['maintenanceAuditingReducer', 'request']),
    response: state.getIn(['maintenanceAuditingReducer', 'response']),
    options: state.getIn(['maintenanceAuditingReducer', 'options']),

    alert: state.getIn(['alertReducer', 'alert']),
})

const mapDispatchToProps = (dispatch) => ({
    findAuditableMCards: (casePk) => {
        dispatch(forwardToFindAuditableMCards(casePk));
        clean(dispatch);
    },

    sortCards: (cards, order) => {
        dispatch(forwardToSortAuditableMaintenanceCards(cards, order));
        clean(dispatch);
    },

    assignAuditingPant: (card) => {
        let editing = {
            card: card,
            type: "PANT"
        }
        dispatch(forwardToAssignAuditingCardTarget(editing));
        clean(dispatch);
    },

    assignAuditingClothes: (card) => {
        let editing = {
            card: card,
            type: "CLOTH"
        }
        dispatch(forwardToAssignAuditingCardTarget(editing));
        clean(dispatch);
    },

    findPhotos: (cardId) => {
        dispatch(forwardToFindPhotosByCard(cardId));
    },
    changePhotoListPreviousPage: (previousPage) => {
        dispatch(changePhotoListPreviousPage(previousPage));
    }

})

const MaintenanceAuditCardsContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(MaintenanceAuditCardsComponent)

export default MaintenanceAuditCardsContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceAuditCardsContainer.jsx